module.exports = __webpack_public_path__ + "static/media/de04.0ee2f56a.jpg";